import LegalLayout from './LegalLayout';

const H = ({ children }) => (
  <h2 className="text-xl font-heading text-foreground mt-8 mb-2">{children}</h2>
);

const RefundCancellation = () => (
  <LegalLayout
    title="Refund & Cancellation Policy"
    description="Cancellation timelines, refund eligibility, and how refunds are processed for bookings at Rudragarh Resort."
    path="/refund-cancellation"
    updated="July 2026"
  >
    <p>
      We understand that plans can change. This policy explains our cancellation timelines
      and how refunds are handled for direct bookings made with Rudragarh Resort. Bookings
      made through third-party platforms (OTAs) are governed by that platform's policy.
    </p>

    <H>Cancellation &amp; Refund Timeline</H>
    <ul className="list-disc pl-6 space-y-1">
      <li><b>7 or more days before check-in</b> — full refund, less any payment-gateway charges.</li>
      <li><b>3 to 7 days before check-in</b> — 50% of the booking amount is refunded.</li>
      <li><b>Less than 72 hours before check-in, or no-show</b> — no refund.</li>
    </ul>

    <H>Peak &amp; Festival Periods</H>
    <p>
      Bookings for peak, festival, and long-weekend dates (for example New Year, Diwali,
      and the Jaisalmer Desert Festival) may be non-refundable or carry different terms.
      Any such condition will be stated clearly at the time of booking and takes precedence
      over the standard timeline above.
    </p>

    <H>Early Departure &amp; Unused Nights</H>
    <p>
      No refund is provided for early check-out, late arrival, or unused nights once a stay
      has begun.
    </p>

    <H>How to Cancel</H>
    <p>
      To cancel or amend a booking, contact us by email at{' '}
      <a href="mailto:info@rudragarh.com" className="text-gold-500 underline">info@rudragarh.com</a>{' '}
      or by phone/WhatsApp at{' '}
      <a href="tel:+919649611111" className="text-gold-500 underline">+91 96496 11111</a>,
      quoting your booking ID. The cancellation takes effect from the time we receive your
      request. We recommend cancelling as early as possible.
    </p>

    <H>How Refunds Are Processed</H>
    <p>
      Approved refunds are made to the original payment method. Once approved, refunds are
      typically processed within 7–10 business days, though the time for funds to appear in
      your account depends on your bank or card issuer. Payment-gateway fees, where
      applicable, are non-refundable.
    </p>

    <H>Force Majeure</H>
    <p>
      In the event of circumstances beyond reasonable control (such as natural events,
      government restrictions, or travel disruptions), we will work with you in good faith
      to reschedule your stay or offer a credit, at our discretion.
    </p>

    <H>Contact</H>
    <p>
      Rudragarh Resort — Village Damodra, Sam Road, near Jaisalmer, Rajasthan 345001,
      India. Email: <a href="mailto:info@rudragarh.com" className="text-gold-500 underline">info@rudragarh.com</a>,
      Phone: <a href="tel:+919649611111" className="text-gold-500 underline">+91 96496 11111</a>.
    </p>
  </LegalLayout>
);

export default RefundCancellation;
